import React from "react";
import './Intro.css';
import neon  from '../../assets/img/KC-neon-2.jpg';


export default class Intro extends React.Component {

	render() {

		return (
		<div className="intro-container">
        	<div className="intro-img">
				<img src={neon} alt=""/>
			</div>
			<div className="intro-text-container">
				<div>
					<p className="intro-text">WE ARE</p>
					<p className="intro-text">CREATIVE</p>
					<p className="intro-text">TECHNOLOGISTS</p>
				</div>
				<div>
					<p className="intro-text-small item-body">
						We're laying the groundwork for the next generation of Web3, NFT and Crypto products that are both technically advanced and socially relevant.
					</p>
				</div>

			</div>
		</div>
		);
	}
}
